// Startseiten-Sonderfilter fuer die Newcomer-ListView.
//
// Die Keywords werden als Filter (Static-Filter) an die Newcomer-ListView uebergeben und
// serverseitig im PDIteratorEventHandler durch das jeweilige HQL-Prädikat ersetzt. Die
// zugehoerigen Titel-ErgNames ueberschreiben den Breadcrumb-Titel der ListView (siehe
// NewcomerUIListener.onBeforeListViewRender).
//
// Die Keywords MUESSEN mit den Konstanten in
// PDIteratorEventHandler.NewcomerUnansweredFilterKeyword /
// .NewcomerWithoutCourseFilterKeyword uebereinstimmen.

/** PDO-Typ der Newcomer-ListView, auf die die Startseiten-Hinweise verlinken. */
export const NEWCOMER_PD_TYPE = 'ONV.ONV.Newcomer';

/** Filter-Keyword fuer unbeantwortete, aktuelle Newcomer. */
export const FILTER_KEYWORD_UNANSWERED = '$$Newcomer_Unanswered$$';

/** Filter-Keyword fuer aktive Newcomer ohne Kurszuordnung. */
export const FILTER_KEYWORD_WITHOUT_COURSE = '$$Newcomer_WithoutCourse$$';

// Zuordnung Keyword -> Breadcrumb-Titel (ErgName), aufgeloest ueber den ResourceManager.
const TITLE_ERGNAME_BY_KEYWORD: ReadonlyArray<{ keyword: string; titleErgName: string }> = [
    { keyword: FILTER_KEYWORD_UNANSWERED,     titleErgName: 'ONV.ONV.NEWCOMER_UNANSWERED_LV_ERGNAME' },
    { keyword: FILTER_KEYWORD_WITHOUT_COURSE, titleErgName: 'ONV.ONV.NEWCOMER_WITHOUT_COURSE_LV_ERGNAME' },
];

/**
 * Liefert den Titel-ErgName fuer den Breadcrumb, wenn die ListView ueber eines der
 * Startseiten-Keywords gefiltert wird; sonst null.
 */
export function getCustomNewcomerTitleErgName(filter: string | null | undefined): string | null {
    if (!filter)
        return null;

    const match = TITLE_ERGNAME_BY_KEYWORD
        .find(entry => filter.indexOf(entry.keyword) !== -1);
    return match ? match.titleErgName : null;
}
